import Vue from 'vue';
import Vuex from 'vuex';

import mutations from './mutations';
import * as actions from './actions';
import order from './modules/order/order-store';
import config from './modules/config/config-store';
import user from './modules/user/user-store';
import followOA from './modules/follow-official-accounts/follow-official-accounts-store';
import chargeActivity from './modules/charge-activity/charge-activity-store';
import chatVisa from './modules/chat-visa/chat-visa-store';
import { isLocalhost } from '../libs/env';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showLoginBox: false, // 是否显示登录弹窗
    loginBoxPage: 1, // // 登录弹窗显示的页面，1：微信登录，2：账号密码, 3: 手机验证码， 4：忘记密码， 5：注册
    loginFrom: '', // 登录弹窗的来源
    loginNotReload: false, // 登录是否不刷新页面
  },
  mutations,
  actions,
  modules: {
    order,
    config,
    user,
    followOA,
    chargeActivity,
    chatVisa,
  },
  strict: isLocalhost,
});



// WEBPACK FOOTER //
// ./src/store/store.js